// extracted by mini-css-extract-plugin
export default {"spinner":"rGTZv","spinnerLogo":"KUgIf","black":"bYCZG","white":"Fc00y"};